import { createAppSlice } from "@/store/utils";

import { NotificationState } from "./notification.types";
import {
  clearTimers,
  dismissNotification,
  registerVisibilityHandler,
  removeVisibilityListener
} from "./notification.watchdog";

const initialState: NotificationState = {
  permission: typeof Notification !== "undefined" ? Notification.permission : "default"
};

export const notificationSlice = createAppSlice({
  name: "notification",
  initialState,
  reducers: (create) => ({
    requestPermission: create.asyncThunk(
      async () => {
        if (typeof Notification === "undefined") return "denied" as NotificationPermission;
        if (Notification.permission === "granted") return "granted" as NotificationPermission;
        return Notification.requestPermission();
      },
      {
        fulfilled: (state, { payload }) => {
          state.permission = payload;
        }
      }
    ),

    /** Registra o watchdog de visibilidade. Timer só corre quando a aba está em background. */
    registerVisibilityListener: create.asyncThunk(async (_, { dispatch }) => {
      registerVisibilityHandler(dispatch);
    }),

    /** Remove listeners e timers ativos. Chamado no logout. */
    cleanup: create.asyncThunk(async () => {
      clearTimers();
      dismissNotification();
      removeVisibilityListener();
    })
  }),
  selectors: {
    selectNotificationPermission: (state) => state.permission
  }
});

export const notificationSliceActions = notificationSlice.actions;
export const notificationSliceSelectors = notificationSlice.selectors;
